import { render, staticRenderFns } from "./OrderBundle.vue?vue&type=template&id=a8ed04da&scoped=true"
import script from "./OrderBundle.vue?vue&type=script&lang=js"
export * from "./OrderBundle.vue?vue&type=script&lang=js"
import style0 from "./OrderBundle.vue?vue&type=style&index=0&id=a8ed04da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ed04da",
  null
  
)

export default component.exports